import {
  region,
  etbType
} from '@/sui/data/flatten/common'

import go from '@/gojs/go'

function createExportedDatasets (y, p, e) {
  const result = []

  const surv = p.surv
  const mod = p.mod
  const den = p.den
  for (let i = 0; i < den.length; i++) {
    const d = den[i]
    const [disc, spe, subSpe] = go.units.getIncidenceDisciplineAndSpeciality(d.ut)
    const duf = d.uf === '__all__' && !subSpe ? '__spe__' : d.uf
    const r = {
      surv: surv,
      region: region(e.finess),
      finess: e.finess,
      etab: e.name,
      type: etbType(e.type),
      mod: mod,
      disc: disc.Code,
      spe: spe != null ? spe.Code : '__all__',
      uf: duf,
      den: d.den,
      value: d.val
    }

    result.push(r)
  }
  return result
}

export default {
  createExportedDatasets: createExportedDatasets
}
